import React from "react";
import SkeletonElement from "./SkeletonElement";

export default function SkeletonCardNewsSecondary() {
  return (
    <div className="py-20 skeletonWrapper px-9 animate-pulse">
      <SkeletonElement type="thumnailFull" />
      <SkeletonElement type="text" />
      <SkeletonElement type="text" />
    </div>
  );
}
